import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[handle]'
})
export class HandleDirective {

    constructor(private elementRef: ElementRef, renderer: Renderer2) {
        renderer.setAttribute(this.elementRef.nativeElement, 'ngxdraghandle', '');
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/directives/handle.directive.ts